/* AUTAVEX — винятки для EVA (таблиця 2026)
   1) індивідуальні ціни (зелені колонки)
   2) моделі, де група ціни НЕ збігається з типом кузова
      (мінівени та фургони за цінами B, Dodge Ram / Expedition — за M)
   p — [передні кл, передні 5D, повний кл, повний 5D, багажник, 3-й ряд]
   v — variant_id тих самих позицій, null = не виготовляється */

var GB={p:[1650,2250,2390,3250,1950,null],
        v:[46279943520392,46279956463752,46279956496520,46279956529288,46279957708936,null]};
var GM={p:[2450,null,5850,null,2050,1350],
        v:[46279956693128,null,46279956725896,null,46279958331528,46279958397064]};

window.AV_EVA_OV={

 /* —— індивідуальні ціни —— */
 "Chrysler|Grand Voyager":{
   p:[3750,null,6400,null,2050,1350],
   v:[46385795858568,null,46385795891336,null,46279958331528,46279958397064]
 },
 "Dodge|Grand Caravan":{
   p:[2270,null,4950,null,2050,2500],
   v:[46385795924104,null,46385795956872,null,46279958331528,46385800249480]
 },
 "Tesla|Model X":{
   p:[1850,2450,2850,3850,1950,950],
   v:[46385796087944,46385795989640,46385796022408,46385796055176,46279957708936,46385800282248]
 },
 "Tesla|Model X Plaid":{
   p:[1850,2450,2850,3850,1950,950],
   v:[46385796087944,46385795989640,46385796022408,46385796055176,46279957708936,46385800282248]
 },

 /* як фургон: лише передній ряд, решта — через менеджера */
 "Citroen|Spacetourer":{
   p:[2450,null,null,null,null,null],
   v:[46279956758664,null,null,null,null,null],
   ask:true
 },
 "Ford|Expedition (U324) 7 \u043c\u0456\u0441\u0446\u044c":{
   p:[2450,null,null,null,null,null],
   v:[46279956693128,null,null,null,null,null],
   ask:true
 },

 /* —— інша ціна багажника —— */
 "Ford|Mondeo I":   {t:2450,tv:46385800183944},
 "Ford|Mondeo II":  {t:2450,tv:46385800183944},
 "Ford|Mondeo III": {t:2450,tv:46385800183944},
 "Ford|Mondeo IV":  {t:2450,tv:46385800183944},
 "Ford|Mondeo V":   {t:2450,tv:46385800183944},
 "Toyota|Camry VIII (XV70)":{t:2450,tv:46385800183944},
 "Mitsubishi|L200 III":{t:2950,tv:46385800216712},
 "Mitsubishi|L200 IV": {t:2950,tv:46385800216712},
 "Mitsubishi|L200 V":  {t:2950,tv:46385800216712},

 /* —— багажника немає —— */
 "Nissan|Navara I (D22)": {t:null,tv:null},
 "Nissan|Navara II (D23)":{t:null,tv:null},
 "Nissan|Navara II (D40)":{t:null,tv:null}
};

/* —— мінівени та фургони за цінами групи B —— */
['Citroen|Berlingo I','Citroen|Berlingo II','Citroen|Berlingo III','Dacia|Dokker','Fiat|500 L','Fiat|Doblo I','Fiat|Doblo II','Fiat|Doblo III','Ford|C-Max Grand','Ford|C-Max I','Ford|C-Max II','Ford|Galaxy I','Ford|Galaxy II','Ford|Galaxy III','Ford|S-Max','Kia|Carens I (RS)','Kia|Carens II (UN)','Kia|Carens III (RP)','Opel|Combo B','Opel|Combo C','Opel|Combo D','Opel|Combo E','Opel|Meriva A','Opel|Meriva B','Opel|Zafira A','Opel|Zafira B','Opel|Zafira C','Peugeot|Partner I (M49)','Peugeot|Partner II (B9)','Peugeot|Partner III (K9)','Renault|Dokker','Renault|Espace III','Renault|Espace IV','Renault|Espace V','Renault|Grand Modus','Renault|Grand Scenic II','Renault|Grand Scenic III','Renault|Grand Scenic IV','Renault|Scenic I','Renault|Scenic II','Renault|Scenic III','Renault|Scenic IV','Toyota|Prius V','Volkswagen|Caddy II','Volkswagen|Caddy III','Volkswagen|Caddy IV','Volkswagen|Golf Sportsvan','Volkswagen|Sharan I (7M)','Volkswagen|Sharan II (7N)','Volkswagen|Touran I (1T)','Volkswagen|Touran II (5T)']
.forEach(function(k){window.AV_EVA_OV[k]=GB});

/* —— пікапи та кросовери за цінами групи M —— */
['Dodge|Ram 1500','Dodge|Ram Crew Cab','Dodge|Ram Quad Cab','Ford|Expedition Max']
.forEach(function(k){window.AV_EVA_OV[k]=GM});

window.AV_EVA_OVGET=function(brand,model){
  if(!brand||!model)return null;
  var k=String(brand).trim()+'|'+String(model).trim();
  return window.AV_EVA_OV[k]||null;
};
